import { BaseApi } from '@shared/config';
import type { GetCurrenciesRequest, GetCurrenciesResponse } from './types';

class CurrencyApi extends BaseApi {
  getCurrencies = (
    params: GetCurrenciesRequest
  ): Promise<GetCurrenciesResponse> => {
    return this.instance.get('/currencies', { params });
  };
}

export const currencyApi = new CurrencyApi();
